import { doc, getDocFromCache, getDocFromServer } from "firebase/firestore";
import { _firebase } from "../../services/firebase.init";
import { generateFirestoreConnection } from "../../services/firebase.generateFirestoreConnection";

// types
import { QueueItem } from "./types";
import {
  getTargetFromPath,
  USERS_COLLECTION,
} from "wombat-global/src/constants";
import { isEmpty } from "wombat-global/src/utilities/empty";

export async function resolveQueueItem(
  task: QueueItem,
  completeTask: (_task: QueueItem) => void = () => null,
  errorTask: (_task: QueueItem, err: unknown) => void = () => null,
) {
  try {
    const fb = await generateFirestoreConnection(getTargetFromPath(task.path));
    const clientDoc = await getDocFromCache(doc(fb, task.path)).catch((err) => {
      // console.log(err);
      return undefined;
    });

    // console.log(clientDoc?.data()?.publishedAt, {publishedAt: task.meta.publishedAt})
    // console.log(clientDoc?.data()?.builtAt, { builtAt: task.meta.builtAt} )
    // console.log(clientDoc, task.meta);

    /**
     * If client doc has the same published date as the server doc published date. skip server fetch
     */
    if (
      (task.meta.builtAt && clientDoc?.data()?.builtAt >= task.meta.builtAt) || // prettier-ignore
      (task.meta.updatedAt &&
        clientDoc?.data()?.updatedAt >= task.meta.updatedAt) || // prettier-ignore
      (task.meta.createdAt &&
        clientDoc?.data()?.createdAt == task.meta.createdAt) || // prettier-ignore
      (task.meta.publishedAt &&
        clientDoc?.data()?.publishedAt >= task.meta.publishedAt) // prettier-ignore
    ) {
      completeTask(task);
      // oxlint-disable-next-line
      console.info(task.path, "hit - up to date");
      return clientDoc?.data();
    }

    /**
     * return cached values if cache exists, and offline or theres no task meta requirements on the cache freshness
     * allow empty object cache hit
     */
    if (
      (!navigator.onLine || isEmpty(task.meta)) &&
      clientDoc?.exists &&
      Boolean(clientDoc?.data())
    ) {
      completeTask(task);
      // oxlint-disable-next-line no-console
      console.info(task.path, "hit - stale");
      return clientDoc?.data();
    }

    const d = await getDocFromServer(doc(fb, task.path));
    // oxlint-disable-next-line
    console.log(task.path, "cached", d.data());
    if (task.path.includes(USERS_COLLECTION + "/") && d.data() === undefined) {
      // oxlint-disable-next-line
      console.error("Cache error retrieving user", d, d.data());
      throw Error("undefined user found in cache");
    }
    completeTask(task);
    return d.data();
  } catch (err) {
    // oxlint-disable-next-line
    console.log(err);
    errorTask(task, err);
  } finally {
    // oxlint-disable-next-line
    // console.log(task.path, "finally");
  }
}
